import { register } from "@rill/loader";

register(
  {
    name: "exercisesVolume",
    meta: ["exercise"],
  },
  async function (
    { api, momentTZ },
    { period, start, end, proxyAthlete, reqSource }
  ) {
    start = momentTZ(start).toDate();
    end = momentTZ(end).toDate();
    return await (
      await api("exercise-metric", {
        query: { period, start, end, type: "volume", proxyAthlete, reqSource },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesVolumeForCycle",
    meta: ["exercise"],
  },
  async function ({ api }, values, proxyAthlete, reqSource) {
    const cycle = {
      id: values.id,
      week: values.week,
      session: values.session,
      program: values.program,
    };
    return await (
      await api("exercise-metric", {
        query: { cycle, type: "cycle-volume", proxyAthlete, reqSource },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesLifts",
    meta: ["exercise"],
  },
  async (
    { api, momentTZ },
    { period, start, end, proxyAthlete, reqSource }
  ) => {
    start = momentTZ(start).toDate();
    end = momentTZ(end).toDate();
    return await (
      await api("exercise-metric", {
        query: { period, start, end, type: "lifts", proxyAthlete, reqSource },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesLiftsForCycle",
    meta: ["exercise"],
  },
  async ({ api, momentTZ }, values, proxyAthlete, reqSource) => {
    const cycle = {
      id: values.id,
      week: values.week,
      session: values.session,
      program: values.program,
    };
    return await (
      await api("exercise-metric", {
        query: { cycle, type: "cycle-lifts", proxyAthlete, reqSource },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesVolumeSplitCoreAccessory",
    meta: ["exercise"],
  },
  async (
    { api, momentTZ },
    { period, start, end, proxyAthlete, reqSource }
  ) => {
    start = momentTZ(start).toDate();
    end = momentTZ(end).toDate();
    return await (
      await api("exercise-metric", {
        query: {
          period,
          start,
          end,
          type: "volume-split-core-accessory",
          proxyAthlete,
          reqSource,
        },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesVolumeSplitRawEquipped",
    meta: ["exercise"],
  },
  async (
    { api, momentTZ },
    { period, start, end, proxyAthlete, reqSource }
  ) => {
    start = momentTZ(start).toDate();
    end = momentTZ(end).toDate();
    return await (
      await api("exercise-metric", {
        query: {
          period,
          start,
          end,
          type: "volume-split-raw-equipped",
          proxyAthlete,
          reqSource,
        },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesVolumeGroupZones",
    meta: ["exercise"],
  },
  async (
    { api, momentTZ },
    { period, start, end, proxyAthlete, reqSource }
  ) => {
    start = momentTZ(start).toDate();
    end = momentTZ(end).toDate();
    return await (
      await api("exercise-metric", {
        query: {
          period,
          start,
          end,
          type: "volume-group-zones",
          proxyAthlete,
          reqSource,
        },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesVolumeGroupZonesForCycle",
    meta: ["exercise"],
  },
  async ({ api, momentTZ }, values, proxyAthlete, reqSource) => {
    const cycle = {
      id: values.id,
      week: values.week,
      session: values.session,
      program: values.program,
    };
    return await (
      await api("exercise-metric", {
        query: { cycle, type: "volume-group-zones", proxyAthlete, reqSource },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesVolumeMean",
    meta: ["exercise"],
  },
  async (
    { api, momentTZ },
    { period, day, timeSpan, proxyAthlete, reqSource }
  ) => {
    const [timeSpanInterval, timeSpanPeriod] = timeSpan.split("-");
    const end = momentTZ(day).toDate();
    const start = momentTZ(end)
      .subtract(Number(timeSpanInterval), timeSpanPeriod)
      .toDate();
    return await (
      await api("exercise-metric", {
        query: {
          period,
          start,
          end,
          type: "volume-mean",
          proxyAthlete,
          reqSource,
        },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesRPETable",
    meta: ["exercise"],
  },
  async (
    { api, momentTZ },
    { primary, start, end, proxyAthlete, reqSource }
  ) => {
    start = momentTZ(start).toDate();
    end = momentTZ(end).toDate();
    return await (
      await api("exercise-metric", {
        query: {
          start,
          end,
          primary,
          type: "rpe-table",
          proxyAthlete,
          reqSource,
        },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesRecordsLoad",
    meta: ["exercise"],
  },
  async ({ api, momentTZ }, { start, end, proxyAthlete, reqSource }) => {
    start = momentTZ(start).toDate();
    end = momentTZ(end).toDate();
    return await (
      await api("exercise-metric", {
        query: {
          start,
          end,
          type: "personal-records-load",
          proxyAthlete,
          reqSource,
        },
      })
    ).json();
  }
);

register(
  {
    name: "exercisesRecordsLoadWithAssistants",
    meta: ["exercise"],
  },
  async ({ api, momentTZ }, { start, end, proxyAthlete, reqSource }) => {
    start = momentTZ(start).toDate();
    end = momentTZ(end).toDate();
    return await (
      await api("exercise-metric", {
        query: {
          start,
          end,
          type: "personal-records-load-with-assistants",
          proxyAthlete,
          reqSource,
        },
      })
    ).json();
  }
);
